import { useEffect } from "react";

import "./Itdept.css";
import {
  Backtotop,
  Floatinmenu,
  Underline,
  Deptvision,
  Deptmission,
} from "../../widgets";

import { Accordion, Hodmsg,Listformat, Timeline } from "../../components";
import {
  it_dept_menu,
  it_mission,
  it_vision,
  it_hod,
  it_stud_data,
  it_peo,
  it_outcomes,
  it_spec_outcomes,
} from "../../constants/it_dept";

import { RadialMenu } from "../../components";

import { FaComputer } from "react-icons/fa6";
const it =
  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/it/IT_DEPT_ADMIN_BLOCK.webp";

const Itdept = () => {
  useEffect(() => {
    document.title = "ACCET-IT Department";
  }, []);
  return (
    <div className="itdept">
      <div className="itbg">
        <div className="itheading">Department of Information Technology</div>
      </div>
      <section className="itdark">
        <div className="dept_float_menu">
          {/* <Floatinmenu logo={FaComputer} head="Menu" links={it_dept_menu} /> */}
        </div>
        {/* <RadialMenu menu_links={it_dept_menu}/> */}
        {/* <div className="it_hod">
        <Underline heading="HOD's Message"/>
        <Hodmsg name={it_hod.name} designation={it_hod.designation} pic={it_hod.pic} content={it_hod.content}/>
        </div> */}
        <div className="it_vision_mission">
          <Underline heading="Our Vision & Mission" />
          <Deptvision visiondata={it_vision.visiondata} />
          <Deptmission points={it_mission} />
        </div>

        <div className="it_peo_area">
          <div className="it_peo">
            <Underline heading="Program Education Objectives" />
            {it_peo.map((item) => (
              <Timeline
                key={item.id}
                head={item.head}
                house={item.house}
                content={item.content}
              />
            ))}
          </div>

          <div className="it_outcomes">
            <Underline heading="Program Outcomes" />
            <Listformat points={it_outcomes} />
          </div>
          <div className="it_spec_outcomes">
            <Underline heading="Program Specific Outcomes" />
            <Listformat points={it_spec_outcomes} />
          </div>
        </div>
      </section>

      <Backtotop />
    </div>
  );
};

export default Itdept;
